import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import GUIset_1Text1Combo1MultiLine from "./gui/GUIset_1Text1Combo1MultiLine";
import Timer from "./TheTimer";
import Template from "./TheTemplate";

const Search = () => {

	const pageTitle = "Search Algorithm - Linear Search vs Binary Search";
	const title = "Linear Search vs Binary Search"; 
	const desc = "";

	const [selected1, setSelected1] = useState({
		value: 0,
		label: "Greater than or equal to (number)",
	});

	const selecter_option = [
		{ value: 0, label: "Greater than or equal to (number)" },
		{ value: 1, label: "Less than or equal to (number)" },
		{ value: 2, label: "Greater than or equal to (string)" },
		{ value: 3, label: "Less than or equal to (string)" },
	];

	//-----------------------------

	//variable
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result
	const [guiTxt, guiTxtChange] = useState("500"); 
	const [guiTxtArea, guiTxtAreaChange] = useState(
		"1\n5\n11\n18\n22\n30\n33\n39\n41\n47\n55\n58\n65\n68\n76\n81\n83\n85\n87\n94\n107\n113\n116\n118\n122\n129\n131\n137\n151\n157\n160\n167\n173\n181\n185\n189\n192\n198\n200\n207\n212\n216\n221\n233\n238\n245\n249\n255\n259\n264\n271\n278\n285\n306\n310\n312\n321\n324\n328\n336\n344\n349\n357\n362\n370\n375\n393\n398\n403\n407\n415\n422\n425\n437\n446\n449\n455\n460\n474\n477\n483\n492\n499\n504\n512\n519\n521\n527\n534\n540\n548\n555\n560\n566\n579\n586\n591\n597\n602\n606"
	);

	//-----------------------------
	useEffect(() => {
		document.title = pageTitle;
	}, []);

	//Main Function
	const buttonClick1 = () => {
		guiTxtAreaChange("");
	};

	const buttonClick2 = () => {
		process();
		BuildResult();
	};

	function selection_handle(e) {
		setSelected1(e);
	}
	//PROCESS =========================================================================================================

	// const childRef = useRef(null); //Result component at bottom
	var txt_result; //processing time
	//redo because time is very low
	var redo_time = 1000000;
	var redo_i = 0;
	
	var txt_log = "";

	function process() {
		txt_result = "";
		txt_log = "";
		//Generate Data from GUI -----------------------
		var sortedList = guiTxtArea.split("\n");
		var targetValue = guiTxt;
		//---------------
		if(selected1.value < 2){
			sortedList = sortedList.map((str) => parseInt(str, 10));
			targetValue = parseInt(targetValue);
			txt_result += "Input as Numbers\n";
		}
		else{
			txt_result += "Input as Strings\n";
		}
		//------
		let indexOfParenthesis = selected1.label.indexOf("(");
		let textBeforeParenthesis = selected1.label.substring(0, indexOfParenthesis);
		//
		txt_result += "Find the first value that is " + textBeforeParenthesis.toLowerCase() + targetValue +  "\n";
		txt_result += "n: " + sortedList.length + " (#0-" + (sortedList.length-1) + ")\n";
		//---------------
		// var findGreater = selecter_option.value % 2 == 1 ? false : true;
		var temp = null;
		var tempTxt = "";
		//
		var r = 1;
		var n = sortedList.length;
		if (n <= 1000) {
			r = redo_time;
		} 
		else if (n <= 10000) {
			r = redo_time / 10;
		} 
		else if (n <= 100000) {
			r = redo_time / 100;
		} 
		else if (n <= 1000000) {
			r = redo_time / 1000;
		} 
		else  {
			r = 1;
		}
		//LINEAR ----------------------------
		Timer.start();
		for (redo_i = 0; redo_i < r; redo_i++) {
			if(selected1.value%2 == 0){
				temp = linear_findFirstGreaterThanOrEqualValue(sortedList, targetValue, redo_i)
			}
			else{
				temp = linear_findLastLessThanOrEqualValue(sortedList, targetValue, redo_i)
			}
		}
		// txt_result += "time test >> " + r  + " >> " + sortedList.length + "\n";
		tempTxt = Timer.stop_print();
		if(temp == null){
			txt_result += 'NOT FOUND\n';
		}
		//----------------------------------------
		txt_result += "\n";
		var direction = selecter_option.value % 2 == 1 ? "(Forward)" : "(Backward)";
		txt_result += "Linear Search " + direction + "\n";
		txt_result += tempTxt + ` (${redo_time} redo times)` + "\n";
		txt_result += "\n";
		//BINARY ---------------------------------
		txt_result += "Binary Search\n";
		Timer.start();
		for (redo_i = 0; redo_i < r; redo_i++) {
			let firstLine = redo_i == 0 ? true : false;
			if(selected1.value%2 == 0){
				// temp = binary_findFirstGreaterThanOrEqualValue(sortedList, targetValue, false)
				temp = binary_findFirstGreaterThanOrEqualValue(sortedList, targetValue, firstLine)
			}
			else{
				// temp = binary_findLastLessThanOrEqualValue(sortedList, targetValue, false)
				temp = binary_findLastLessThanOrEqualValue(sortedList, targetValue, firstLine)
			}
		}
		tempTxt = Timer.stop_print();
		txt_result += tempTxt + ` (${redo_time} redo times)` + "\n";
		if(txt_log != ""){ txt_result += "\nOrder\n" + txt_log; }
		//---------------------------------
	}


		// for (var a = bestSet.items.length - 1; a >= 0; a--) {
		// 	if (t != "") {
		// 		t += ",";
		// 	}
		// 	t += bestSet.items[a].name;
		// }
		// txt_result += "\r\nItems: " + t;
		// txt_result += "\r\nSize: " + bestSet.w;
		// txt_result += "\r\nValue: " + bestSet.v;
		// //
		// console.log("Optimal List: " + t);
		// console.log("Optimal Value: " + bestSet.v);
		// //--------------------------
		// callChild_createResult(itemList, txt_result);



	//-----------------
	function linear_findLastLessThanOrEqualValue(sortedList, targetValue, x) {
		let result = null;
		for (let i = sortedList.length - 1; i >= 0; i--) {
		  if (sortedList[i] <= targetValue) {
			// if(x == 0) {txt_result += "Item found: " + sortedList[i] + ", item #" + i + "\n";}
			if(x == 0) {txt_result += "Stop at " + sortedList[i] + ", #" + i + "\n";}
			result = sortedList[i];
			break;
		  }
		}
		return result;
	  }

	  function linear_findFirstGreaterThanOrEqualValue(sortedList, targetValue, x) {
		let result = null;	  
		for (let i = 0; i < sortedList.length; i++) {
		  if (sortedList[i] >= targetValue) {
			// if(x == 0) {txt_result += "Item found: " + sortedList[i] + ", item #" + i + "\n";}
			if(x == 0) {txt_result += "Stop at " + sortedList[i] + ", #" + i + "\n";}
			result = sortedList[i];
			break;
		  }
		}	  
		return result;
	  }


	function binary_findFirstGreaterThanOrEqualValue(arr, target, printLog = false) {
		let left = 0;
		let right = arr.length - 1;
		let result = -1; // Initialize the result variable to keep track of the first greater element found
		var i = 1;
		while (left <= right) {
		  const mid = Math.floor((left + right) / 2);
		  let v = arr[mid];
		  if(printLog){ 
			if(txt_log != ""){ txt_log += "\n";}
			txt_log = txt_log + i + ". #"+ mid + " : " + v; 
			i++;
		}
			if(v == target){break;}
	  
		  if (v > target) {
			// If the middle element is greater than the target
			// Update the result and search in the left half
			result = mid;
			right = mid - 1;
		  } else {
			// If the middle element is less than or equal to the target
			// Search in the right half
			left = mid + 1;
		  }
		}	  
		// Return the element found using the result index
		return result >= 0 ? arr[result] : null;
	  }

	  
	  function binary_findLastLessThanOrEqualValue(arr, target, printLog = false) {
		let left = 0;
		let right = arr.length - 1;
		let resultIndex = -1;
		var i = 1;
		while (left <= right) {
		  const mid = Math.floor((left + right) / 2);
	  
		  let v = arr[mid];
		  if(printLog){ 
				if(txt_log != ""){ txt_log += "\n";}
				txt_log = txt_log + v; 
				i++;
			}

			if(v == target){break;}
		  if (v<= target) {
			resultIndex = mid;
			left = mid + 1; // Continue searching in the right half for a potential better match
		  } else {
			right = mid - 1; // Search in the left half
		  }
		}
	  
		if (resultIndex !== -1) {
		  return arr[resultIndex];
		}
	  
		// If there's no element less than or equal to the target, you can return an appropriate value, e.g., null or undefined.
		return null;
	  }
	  





	  
	function BuildResult() {
		partResultChange(
			Template.simple3size("key1", "Result", "", txt_result, 22, 20, 22)
		);
	}
	  
	
	//----------------------------------------------------

	return (
		<GUIset_1Text1Combo1MultiLine
			title={title}
			width1={200}
			comboFist={false}
			// desc={"Compare various algorithm for sorting"}
			//txt
			label1={"Target"}
			guiTxt={guiTxt}
			isNumOnly={false}
			guiTxtChange={guiTxtChange}
			//selector
			label2={""}
			selecter_option={selecter_option}
			selectedOption={selected1}
			setSelectedOption={selection_handle}
			//area
			labelArea = {"Sorted Data"}
			guiTxtArea = {guiTxtArea}
			guiTxtAreaChange = {guiTxtAreaChange}
			placeholder={"sorted values (one per line)"}
			//
			but1_label = {"Clear"}
			but2_label = {"Sort"}
			but1_ratio = {1}
			but2_ratio = {3}
			buttonClick1 = {buttonClick1}
			buttonClick2 = {buttonClick2}
			//oth
			txtButton={"Sort"}
			buttonClick={buttonClick1}
			//
			partResult={partResult}			
		/>
	);
};

export default Search;
